import { ReactElement, useState } from 'react';
import {
  Datagrid,
  Filter,
  FunctionField,
  List,
  TextField,
  useListController,
  useTranslate,
} from 'react-admin';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { DashboardContent } from 'src/layouts/dashboard';
import { PermissionGuard } from 'src/routes/components';
import { Box, Card, Dialog, Stack, Button as MUIButton, Chip, Typography } from '@mui/material';
import ErrorPage403 from 'src/pages/error/403';
import XDateField from '../../components/XDateField';
import AuditLogTable from '../../components/AuditLog/AuditLogTable';

const ListFilter = (props: any) => {
  const { filterValues } = useListController();
  return <Filter {...(props || {})}></Filter>;
};

const getActionColor = (action: string) => {
  switch (action.toLowerCase()) {
    case 'create':
      return 'success';
    case 'update':
      return 'info';
    case 'delete':
      return 'error';
    default:
      return 'default';
  }
};

const getMethodColor = (method: string) => {
  switch (method.toUpperCase()) {
    case 'POST':
      return 'success';
    case 'PUT':
    case 'PATCH':
      return 'info';
    case 'DELETE':
      return 'error';
    case 'GET':
      return 'default';
    default:
      return 'default';
  }
};

const View = () => {
  const translate = useTranslate();
  
  return (
    <PermissionGuard resource="audit-logs" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs heading={translate('resource.auditLogs')} />
        <Card sx={{ mt: 3, pb: 2, paddingTop: 2 }}>
          <List
            actions={false}
            empty={false}
            filters={<ListFilter />}
            perPage={10}
            exporter={false}
          >
            <AuditLogTable showId showNewData showOldData showResource/>
          </List>
        </Card>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
